import { createAction, props } from '@ngrx/store';

export const getSiteStatuses = createAction('[SiteStatus] Get Site Statuses');

export const getSiteStatusesSuccess = createAction('[SiteStatus] Get Site Statuses Success', props<{ data: any }>());

export const getSiteStatusesFailure = createAction('[SiteStatus] Get Site Statuses Failure', props<{ error: any }>());
